(function () {
  if (window.__productCarouselLoaded) return;
  window.__productCarouselLoaded = true;

  function getStep(track) {
    var firstCard = track.querySelector('.product-carousel__card');
    if (!firstCard) return track.clientWidth;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return firstCard.getBoundingClientRect().width + gap;
  }

  function updateNavState(root) {
    var track = root.querySelector('.product-carousel__track');
    var prevBtn = root.querySelector('.product-carousel__nav-btn--prev');
    var nextBtn = root.querySelector('.product-carousel__nav-btn--next');
    if (!track) return;

    var maxScroll = track.scrollWidth - track.clientWidth - 1;
    var atStart = track.scrollLeft <= 0;
    var atEnd = track.scrollLeft >= maxScroll;

    if (prevBtn) {
      prevBtn.classList.toggle('is-disabled', atStart);
      prevBtn.disabled = atStart;
    }
    if (nextBtn) {
      var noOverflow = maxScroll <= 0;
      nextBtn.classList.toggle('is-disabled', atEnd || noOverflow);
      nextBtn.disabled = atEnd || noOverflow;
    }
  }

  function initCarousel(root) {
    if (root.dataset.pcInit === 'true') return;
    root.dataset.pcInit = 'true';

    var track = root.querySelector('.product-carousel__track');
    var prevBtn = root.querySelector('.product-carousel__nav-btn--prev');
    var nextBtn = root.querySelector('.product-carousel__nav-btn--next');
    if (!track) return;

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(track), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep(track), behavior: 'smooth' });
      });
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateNavState(root);
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      updateNavState(root);
    });

    updateNavState(root);
  }

  function initAll() {
    document.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-carousel]');
    if (root) initCarousel(root);
  });
})();
